import React from "react";
import Button from "_shared/components/Button/Button";
import CustomModal from "../Modal";
import styles from "./AlertModal.module.scss";

interface Props
  extends Omit<React.ComponentProps<typeof CustomModal>, "children"> {
  type: "error" | "success";
  message: string;
}

const AlertModal: React.FC<Props> = ({ type, message, onClose, ...rest }) => {
  return (
    <CustomModal onClose={onClose} {...rest}>
      <div className={styles.container} data-type={type}>
        {type === "error" ? (
          <i className="fas fa-exclamation-triangle" />
        ) : (
          <i className="fas fa-check-circle" />
        )}
        <p>{message}</p>
        <Button onClick={onClose} fullWidth>
          OK
        </Button>
      </div>
    </CustomModal>
  );
};

export default AlertModal;
